module.exports = QRCode;